export default __webpack_public_path__ + "static/media/rectangles-no-5.4fa95595.ogg";